export default __webpack_public_path__ + "static/media/app_amazon.d49035f3.svg";